var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"loading-spinner rounded shadow-sm"},[_c('div',{staticClass:"spinner-border spinner-border-sm me-2"}),_c('span',[_vm._v(_vm._s(_vm.text || "Loading..."))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }